import { Dialog, Button } from "@mui/material";
import colorConfigs from "../../../../config/colorConfigs";
import moment from "moment";

type Props = {
    editPopup: boolean;
    hidePopup: () => void;
    particularTransactionDetails: any;
}

export default function TransactionInfo({ editPopup, hidePopup, particularTransactionDetails }: Props) {

    return (
        <>
            <Dialog
                open={editPopup}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '800px',
                        width: '100%',
                        borderRadius: '16px',
                        maxHeight: '70vh',
                        overflowY: 'auto',
                        marginTop: '160px'
                    },
                }}
            >
                <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                    <div className="w-full bg-white p-4 rounded-md">
                        <div className="w-full mt-2">
                            <div className={`w-full`}>
                                <div className={`sticky top-0 z-10 flex justify-between items-center p-2 border-b border-secondary bg-white`}>
                                    <div className="flex items-center gap-1.5">
                                        <h2 className={`text-lg font-semibold text-secondary`}>Transaction Info</h2>
                                    </div>

                                    <button
                                        onClick={hidePopup}
                                        className="absolute right-2 top-2 text-gray-500 hover:text-red-500 transition"
                                    >
                                        <span className="material-symbols-outlined text-[20px]">close</span>
                                    </button>
                                </div>

                                <div className="mt-2 p-2">
                                    <div className="w-full">
                                        <div className="grid grid-cols-2 gap-6">
                                            <div className="space-y-4">
                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium text-secondary`}>Reference</span>
                                                    <span className={`text-sm text-secondary`}>{particularTransactionDetails?.reference}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium text-secondary`}>Status</span>
                                                    <span className={`text-sm text-secondary`}>{particularTransactionDetails?.status}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium text-secondary`}>Item</span>
                                                    <span className={`text-sm text-secondary`}>{particularTransactionDetails?.item}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium text-secondary`}>Gateway</span>
                                                    <span className={`text-sm text-secondary`}>{particularTransactionDetails?.gateway}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium text-secondary`}>Description</span>
                                                    <span className={`text-sm text-secondary`}>{particularTransactionDetails?.description}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium text-secondary`}>Created At</span>
                                                    <span className={`text-sm text-secondary`}>{particularTransactionDetails?.createdAt
                                                        ? moment(new Date(particularTransactionDetails.createdAt)).format("MM/DD/YYYY hh:mm a")
                                                        : ""}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium text-secondary`}>Authorization Charged?</span>
                                                    <span className={`text-sm text-secondary`}>{particularTransactionDetails?.authorizationCharged ? "Yes" : "No"}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium text-secondary`}>UUID</span>
                                                    <span className={`text-sm text-secondary`}>{particularTransactionDetails?.uuid}</span>
                                                </div>
                                            </div>

                                            <div className="space-y-4">
                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium text-secondary`}>Contact</span>
                                                    <span className={`text-sm text-secondary`}>{particularTransactionDetails?.contact}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium text-secondary`}>Amount</span>
                                                    <span className={`text-sm text-secondary`}>{particularTransactionDetails?.amount}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium text-secondary`}>Refunded Amount</span>
                                                    <span className={`text-sm text-secondary`}>{particularTransactionDetails?.refundedAmount}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium text-secondary`}>Status Description</span>
                                                    <span className={`text-sm text-secondary`}>{particularTransactionDetails?.statusDescription}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium text-secondary`}>Charged At</span>
                                                    <span className={`text-sm text-secondary`}> {particularTransactionDetails?.chargedAt
                                                        ? moment(new Date(particularTransactionDetails.chargedAt)).format("MM/DD/YYYY hh:mm a")
                                                        : ""}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex items-center gap-1.5 mt-5">
                                            <h2 className={`text-lg font-semibold text-secondary`}>Credit Card Details</h2>
                                        </div>
                                        <hr />

                                        <div className="grid grid-cols-2 gap-6 mt-4">
                                            <div className="space-y-4">
                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium text-secondary`}>Cardholder's Name</span>
                                                    <span className={`text-sm text-secondary`}>{particularTransactionDetails?.cardholderName}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium text-secondary`}>Last 4 Digits</span>
                                                    <span className={`text-sm text-secondary`}>....{particularTransactionDetails?.last4Digits}</span>
                                                </div>
                                            </div>

                                            <div className="space-y-4">
                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium text-secondary`}>Brand</span>
                                                    <span className={`text-sm text-secondary`}>{particularTransactionDetails?.brand}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium text-secondary`}>Zip Code</span>
                                                    <span className={`text-sm text-secondary`}>{particularTransactionDetails?.zipCode}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="sticky bottom-0 flex justify-start gap-4 p-4 bg-white z-10">
                                            <Button
                                                variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.cancel.bg,
                                                    border: colorConfigs.btn.cancel.border,
                                                    color: colorConfigs.btn.cancel.color
                                                }}
                                                onClick={hidePopup}
                                            >
                                                Close
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    )
}